import type {SyntheticEvent} from 'react';
import {preventDefault} from './preventDefault';
import {stopPropagation} from './stopPropagation';

/**
 * Silence an event
 * @param event Event
 *
 * @example
 * ```ts
 * silenceEvent(event);
 * ```
 */
export const silenceEvent = <E extends SyntheticEvent | Event>(event: E) => {
	preventDefault(event);
	stopPropagation(event);
};

export default silenceEvent;
